'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as CosIndexActions from 'DesignData/actions/CosIndexConnections';
import * as RequestStatus from 'DesignData/enums/RequestStatus';
import * as cosIndexSelectors from 'DesignData/selectors/cosIndexConnections';
import { dependentsByCategory as DependentsByCategoryPropType } from 'DesignData/propTypes/finder';

function makeMapStateToProps() {
  const getDependentsByCategory = cosIndexSelectors.makeGetParentConnectionsByCategory();
  const getDependentsCount = cosIndexSelectors.makeGetParentConnectionsCount();
  const getFetchDependentsStatus = cosIndexSelectors.makeGetFetchStatus();
  const getFetchDependentsError = cosIndexSelectors.makeGetFetchError();
  return (state, ownProps) => {
    const {
      fileId: assetId
    } = ownProps;
    return {
      dependentsByCategory: getDependentsByCategory(state, {
        assetId
      }),
      dependentsCount: getDependentsCount(state, {
        assetId
      }),
      fetchDependentsError: getFetchDependentsError(state, {
        assetId
      }),
      fetchDependentsStatus: getFetchDependentsStatus(state, {
        assetId
      })
    };
  };
}

const mapDispatchToProps = {
  fetchDependents: CosIndexActions.fetchForParentConnections
};
export default function withFileDependents(WrappedComponent) {
  class HighOrderWithFileDependents extends Component {
    constructor(...args) {
      super(...args);

      this.fetchDependents = extraParams => {
        const {
          fetchDependents,
          fileId
        } = this.props;
        fetchDependents(fileId, extraParams);
      };
    }

    componentDidMount() {
      this.fetchDependents({
        fields: 'NO_META'
      });
    }

    render() {
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props, {
        fetchDependents: this.fetchDependents
      }));
    }

  }

  HighOrderWithFileDependents.propTypes = {
    dependentsByCategory: DependentsByCategoryPropType,
    dependentsCount: PropTypes.number,
    fetchDependents: PropTypes.func.isRequired,
    fetchDependentsError: PropTypes.instanceOf(Error),
    fetchDependentsStatus: PropTypes.oneOf(Object.values(RequestStatus || {})),
    fileId: PropTypes.number.isRequired
  };
  HighOrderWithFileDependents.defaultProps = {
    dependentsByCategory: {},
    dependentsCount: 0,
    fetchDependentsError: null,
    fetchDependentsStatus: RequestStatus.UNINITIALIZED
  };
  return connect(makeMapStateToProps, mapDispatchToProps)(HighOrderWithFileDependents);
}